import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';
import { HeaderMarginContainer } from 'Deer/components/HeaderComponents/HeaderMarginContainer';
import { VerticallyAlignedFlexContainer } from 'styles/common';

import { SlackLogoSrc } from 'constants/icons';
import { KH_LINKS } from 'constants/knowledgeHubLinks';
import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { getSlackAuthDetails } from 'services/plugins';

import TooltipInfo from 'uiToolkit/TooltipInfo';
import { Typography16, Typography17 } from 'uiToolkit/Typography';

import InstalledButton from '../InstalledButton';
import PluginFeatures from '../pluginFeatures';
import { StyledContainer, Logo } from '../styles';
import AddToSlackButton from './addToSlackButton';
import GuideSection from './guideSection';
import InstallationSection from './installationSection';
import LinkTeamWithChannel from './linkTeamWithChannel';

const thirdPartyType = 'SLACK';

/**
 * @deprecated 8-04-2025
 */
const SlackPlugin = () => {
  const [isActivated, setIsActivated] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showApplauseModule, setShowApplauseModule] = useState(false);

  const getData = () => {
    setLoading(true);
    getSlackAuthDetails()
      .then((res) => setIsActivated(true))
      .catch((err) => setIsActivated(false))
      .finally(() => setLoading(false));
  };

  useEffect(getData, []);

  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        source: 'Company-settings-slack',
      },
    });
  }, []);

  return (
    <StyledContainer>
      <HeaderMarginContainer>
        <Grid container spacing={4}>
          <Grid item>
            <Logo src={SlackLogoSrc} width={80} />
          </Grid>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Grid item xs={6}>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <VerticallyAlignedFlexContainer>
                  <Typography16 gutterBottom>Slack Plugin</Typography16>
                  <TooltipInfo
                    title={KH_LINKS.SLACK.description}
                    linkUrl={KH_LINKS.SLACK.url}
                    leftGutter={1}
                    bottomGutter={1}
                  />
                </VerticallyAlignedFlexContainer>
                <Typography17>
                  Get updates for any Mesh pod on a chosen
                  <br />
                  Slack channel
                </Typography17>
              </Grid>
              <Grid item>
                {!loading && !isActivated ? (
                  <AddToSlackButton disabled={loading} />
                ) : (
                  <InstalledButton isDisabled isLoading={loading} mt={4}>
                    Activated
                  </InstalledButton>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </HeaderMarginContainer>

      {!loading && isActivated && (
        <PluginFeatures
          thirdPartyType={thirdPartyType.toLowerCase()}
          setShowApplauseModule={setShowApplauseModule}
          heading="Link slack channel for public feedback"
        />
      )}
      {isActivated !== null && (
        <LinkTeamWithChannel showApplauseModule={showApplauseModule} isActivated={isActivated} />
      )}
      {!loading && !isActivated && <InstallationSection />}
      <GuideSection />
    </StyledContainer>
  );
};

export default SlackPlugin;
